export default {"src":"/_next/static/media/OKX.dcd3f1ef.svg","height":27,"width":87,"blurWidth":0,"blurHeight":0};